"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HoursOfOperationDailyWithPopup;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _CurrentlyOpenLabel = _interopRequireDefault(require("./CurrentlyOpenLabel"));

function HoursOfOperationDailyWithPopup(props) {
  var displayOpenClosedStatus = props.displayOpenClosedStatus,
      timezone = props.timezone,
      hours = props.hours,
      children = props.children,
      label = props.label,
      secondaryLabel = props.secondaryLabel;
  var visibleFirstDay;

  if (displayOpenClosedStatus && timezone) {
    visibleFirstDay = /*#__PURE__*/_react["default"].createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/_react["default"].createElement(_CurrentlyOpenLabel["default"], {
      hours: hours,
      timezone: timezone
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      name: "caret down"
    }));
  } else {
    visibleFirstDay = /*#__PURE__*/_react["default"].createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/_react["default"].createElement("h4", null, label), /*#__PURE__*/_react["default"].createElement("p", {
      className: "hoo-hours-paragraph"
    }, secondaryLabel), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      name: "caret down"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Popup, {
    trigger: visibleFirstDay,
    content: children,
    basic: true,
    on: "click"
  });
}

HoursOfOperationDailyWithPopup.propTypes = {
  displayOpenClosedStatus: _propTypes["default"].bool.isRequired,
  timezone: _propTypes["default"].string,
  hours: _propTypes["default"].arrayOf(_propTypes["default"].any),
  children: _propTypes["default"].element.isRequired,
  label: _propTypes["default"].string,
  secondaryLabel: _propTypes["default"].string
};
HoursOfOperationDailyWithPopup.defaultProps = {
  timezone: '',
  hours: [],
  label: 'See hours',
  secondaryLabel: ''
};